module.exports = __webpack_public_path__ + "img/mod-12.aabbea5c.svg";